"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _uuid = require("uuid");
var _Select = require("./Select.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 下拉選單
 */

const Select = _ref => {
  let {
    options = [],
    className,
    label,
    onChange,
    onClear,
    disabled,
    message,
    value,
    defaultValue,
    placeholder,
    getPopupContainer = () => document.getElementById("root"),
    dropdownStyle,
    row = false,
    mode,
    showArrow,
    variant,
    allowClear = true,
    // antd 預設 24，但 .ant-select-item 實際高 32px，對不上會導致 9～10 項時沒有捲軸（QB-1830）
    listItemHeight = 32,
    listHeight
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Select.UiSelect, {
    row: row,
    variant: variant,
    className: className
  }, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_antd.Select, {
    mode: mode,
    showArrow: showArrow,
    onChange: onChange,
    onClear: onClear,
    value: value,
    defaultValue: defaultValue,
    allowClear: allowClear,
    disabled: disabled,
    getPopupContainer: getPopupContainer,
    dropdownStyle: dropdownStyle,
    listItemHeight: listItemHeight,
    listHeight: listHeight,
    placeholder: placeholder
  }, options.map(option => {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: (0, _uuid.v4)(),
      value: option.value,
      label: option.name
    }, option.name);
  })), message && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};
var _default = exports.default = Select;
Select.propTypes = {
  options: _propTypes.default.array,
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  message: _propTypes.default.string,
  value: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  onChange: _propTypes.default.func,
  row: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  mode: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  getPopupContainer: _propTypes.default.func,
  dropdownStyle: _propTypes.default.object,
  showArrow: _propTypes.default.bool,
  variant: _propTypes.default.string,
  allowClear: _propTypes.default.bool,
  listItemHeight: _propTypes.default.number,
  listHeight: _propTypes.default.number
};